import styled from "styled-components";

export const HomeContainer = styled.div`
  position: relative;
  width: 100%;
  background: #060622;
  overflow: hidden;
`;